import React from 'react';
import { ChevronDown, Menu } from 'lucide-react';
const LOGO_URL = 'https://static.wixstatic.com/media/b4bd31_e82dc880fa7046a89801e77cf431b6c8~mv2.avif/v1/fill/w_98,h_148,al_c,lg_1,q_80,enc_avif,quality_auto/B%26D.avif';
export function Navbar() {
  return <nav className="bg-dark text-white sticky top-0 z-50" data-id="element-108">
      <div className="flex items-center justify-between py-4 px-6 md:px-12" data-id="element-109">
        {/* Logo */}
        <div className="flex-shrink-0" data-id="element-110">
          <img src={LOGO_URL} alt="B&D Contracting" className="h-16 w-auto object-contain" data-id="element-111" />
        </div>

        {/* Nav Links */}
        <div className="hidden lg:flex items-center gap-10 font-heading font-semibold tracking-wider text-sm" data-id="element-112">
          <a href="#" className="text-primary hover:text-white transition-colors" data-id="element-113">
            HOME
          </a>
          <a href="#" className="hover:text-primary transition-colors flex items-center gap-1" data-id="element-114">
            FIND A JOB
            <ChevronDown size={14} data-id="element-115" />
          </a>
          <a href="#" className="hover:text-primary transition-colors" data-id="element-116">
            PARTNER WITH US
          </a>
          <a href="#" className="hover:text-primary transition-colors" data-id="element-117">
            ABOUT US
          </a>
          <a href="#" className="hover:text-primary transition-colors flex items-center gap-1" data-id="element-118">
            CONTACT
            <ChevronDown size={14} data-id="element-119" />
          </a>
        </div>

        {/* CTA Buttons */}
        <div className="hidden md:flex items-center gap-4" data-id="element-120">
          <button className="bg-primary text-white px-6 py-3 font-heading font-semibold uppercase tracking-wider text-sm hover:bg-primary-hover transition-colors" data-id="element-121">
            JOIN OUR TEAM
          </button>
          <button className="border border-white text-white px-6 py-3 font-heading font-semibold uppercase tracking-wider text-sm hover:bg-white hover:text-dark transition-colors" data-id="element-122">
            EMPLOYEE LOGIN
          </button>
        </div>

        <button className="lg:hidden text-white" data-id="element-123">
          <Menu size={28} data-id="element-124" />
        </button>
      </div>
      {/* Bottom border line */}
      <div className="h-px bg-gray-700 mx-6 md:mx-12" data-id="element-125"></div>
    </nav>;
}